// Packages
import { scrollToHash } from "abmg-components"

// Styles
import "./src/styles/global.css"

// APIs
export { wrapPageElement } from "./gatsby-shared"
export const onRouteUpdate = ({ location }) => {
  scrollToHash(location)
}
